<template>
  <div class="alert_management">
    <v-toolbar dense flat tabs>
      <v-tabs
        text
        slider-color="black"
        color="#616162"
        v-model="currentView"
        @change="changeView()"
      >
        <v-tabs-slider
          v-if="currentView === viewDetails.myAlerts.id"
          :class="{
            'hyp-tabs-slider': currentView === viewDetails.myAlerts.id,
          }"
        ></v-tabs-slider>
        <v-tab :key="viewDetails.myAlerts.id"> My Alerts </v-tab>
        <v-tab :key="viewDetails.exploreContent.id"> Explore Content </v-tab>
      </v-tabs>
      <v-btn
        depressed
        right
        @click="createFunc()"
        class="create-btn"
        color="primary"
      >
        <i class="fa fa-s fa-plus"></i>
        <span class="ml-1">Create New Alert</span>
      </v-btn>
    </v-toolbar>
    <v-tabs-items v-model="currentView">
      <v-tab-item :key="viewDetails.myAlerts.id">
        <AlertDiscontinuedInfo></AlertDiscontinuedInfo>
        <AlertsList @change="updateData"></AlertsList>
      </v-tab-item>
      <v-tab-item :key="viewDetails.exploreContent.id">
        <AlertContentExplorer :currentView="currentView"></AlertContentExplorer>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
/**
 * @Overview Management UI for user Alerts. Allows a user to see, manipulate, and explore the content from an alert.
 */
import lodashGet from "lodash/get";
import { mapGetters } from "vuex";
import { OPEN_ALERT_WIZARD } from "@/store/actions.type";
import { MODULE_PREFIX_ALERTS, MODULE_PREFIX_HOME } from "@/store";
import { VIEW_DETAILS } from "@/common/constants/alert.js";
import {
  EVENT_CATEGORIES,
  EVENT_ACTIONS,
  EVENT_TYPE,
} from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  CHANGE: "change",
  UPDATE: "update",
};

export default {
  name: "AlertManagement",
  components: {
    AlertsList: () => import("@/components/alerts/management/AlertsList"),
    AlertContentExplorer: () =>
      import("@/components/alerts/contentExplorer/AlertContentExplorer"),
    AlertDiscontinuedInfo: () =>
      import("@/components/common/details/AlertDiscontinuedInfo"),
  },
  data() {
    return {
      currentView: VIEW_DETAILS.myAlerts.id,
      viewDetails: VIEW_DETAILS,
    };
  },
  mounted() {
    this.currentView = 0;
    if (lodashGet(this.selectorPanel, "selectedData")) {
      this.currentView = 1;
      this.changeUrl(this.selectorPanel.selectedData);
    }
    this.$emit(EMITTED_ACTIONS.CHANGE, this.currentView);
  },
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      alertsLoading: MODULE_PREFIX_ALERTS + "loading",
    }),
  },
  methods: {
    changeView() {
      this.$emit(EMITTED_ACTIONS.CHANGE, this.currentView);
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.alerts,
        EVENT_ACTIONS.clicked,
        this.currentView === 1 ? "Explore Content" : "My Alerts"
      );
      this.changeUrl();
    },
    changeUrl(item) {
      let url = "/home";
      if (this.currentView === 1) {
        url = `/alerts`;
        if (item && item.alertId) {
          url = `/alerts/${item.alertId}`;
        }
      }
      window.history.replaceState({}, "Seerist", url);
    },
    async createFunc() {
      await this.$store.dispatch(MODULE_PREFIX_ALERTS + OPEN_ALERT_WIZARD, {});
      window.history.replaceState({}, "Seerist", "/home");
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.alert_wizard,
        EVENT_ACTIONS.clicked,
        "Create New Alert"
      );
    },
    updateData(input) {
      this.$emit(EMITTED_ACTIONS.UPDATE, input);
    },
  },
};
</script>

<style scoped>
.theme--light.v-toolbar {
  background-color: inherit;
}
.create-btn {
  color: white !important;
  border-radius: 9px !important;
}
.hyp-tabs-slider {
  background-color: black !important;
  border-color: black !important;
}
</style>
